module.exports = __webpack_public_path__ + "09_long_brown.eb6a740d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/09_long_brown.png
// module id = 9+z4
// module chunks = 0